@if (title) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title-group>
        <mat-card-title>
          @if (closeable) {
            <a class="icon-link" (click)="onDetailsClose()" matTooltip="Close"><mat-icon>close_small</mat-icon></a>
          }
          {{title}}
        </mat-card-title>
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      <ng-template [ngTemplateOutlet]="content"></ng-template>
    </mat-card-content>
  </mat-card>
} @else {
  <ng-template [ngTemplateOutlet]="content"></ng-template>
}


<ng-template #content>
  <ng-content></ng-content>
  @for (row of getSortedDisplayableFields(); track row) {
    @if (row.value && row.value !== ' ') {
      <div class="detail-row" [ngClass]="{'long-text': row.value.length > LONG_TEXT_LENGTH}">
        <div class="detail-label">{{row.key}}</div>
        <div class="detail-value">{{row.value}}</div>
      </div>
    }
  }
</ng-template>
